import { RequestError, SituationCategory, UserAlreadyExistCodeError } from 'types';
import { isProdOrPreProd } from './../common/config/env';

const LOGIN_EXPIRED_STATUS = 488;
const ALREADY_EXISTED_STATUS = 409;

const ALREADY_EXISTED_PROBLEM_CODE: RequestError = 'ALREADY_EXISTS';

const USER_EMAIL_ALREADY_EXISTED_CODE_ERROR: UserAlreadyExistCodeError = 'Email';
const USER_USERNAME_ALREADY_EXISTED_CODE_ERROR: UserAlreadyExistCodeError = 'Username';

const UPDATE_PASSWORD_WRONG_TEMPORARY_PWD = 'Not Authorized';

const SELECTED_CARRIAGES_REQUIRED = 'SelectedCarriages required';

const SITUATION_CATEGORY: { [key: string]: SituationCategory } = {
  PRE_OP: 'PRE_OP',
  OP: 'OP',
  POST_OP: 'POST_OP',
};

const TRAIN_CONFIGURATION = {
  OUIGO: {
    FIRST_TRAIN: [1, 2, 3, 4, 5, 6, 7, 8],
    SECOND_TRAIN: [11, 12, 13, 14, 15, 16, 17, 18],
  },
  OUIGO_LC: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  OUIGO_LB: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
  OUIGO_ESP: {
    FIRST_TRAIN: [1, 2, 3, 4, 5, 6, 7, 8],
    SECOND_TRAIN: [9, 10, 11, 12, 13, 14, 15, 16],
  },
};

const AFTER_TIME_WARNING = isProdOrPreProd ? '23:45' : '11:30';
const BEFORE_TIME_WARNING = isProdOrPreProd ? '05:00' : '14:30';

const HISTORISATION_REFRESH_DELAY = 120000;
const SEND_COMMUNCIATION_PLACEHOLDERS = ['test', 'essai', 'jj/mm/aa', 'jj/mm/aaaa'];

export default {
  LOGIN_EXPIRED_STATUS,
  ALREADY_EXISTED_STATUS,
  ALREADY_EXISTED_PROBLEM_CODE,
  USER_EMAIL_ALREADY_EXISTED_CODE_ERROR,
  USER_USERNAME_ALREADY_EXISTED_CODE_ERROR,
  UPDATE_PASSWORD_WRONG_TEMPORARY_PWD,
  SITUATION_CATEGORY,
  TRAIN_CONFIGURATION,
  SELECTED_CARRIAGES_REQUIRED,
  AFTER_TIME_WARNING,
  BEFORE_TIME_WARNING,
  SEND_COMMUNCIATION_PLACEHOLDERS,
  HISTORISATION_REFRESH_DELAY,
};
